import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

// components
import Button from './_ui/DomexButton'

export default class Modal extends React.Component {

  static propTypes = {
    buttonText: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    text: PropTypes.any.isRequired,
    visible: PropTypes.bool.isRequired,
  }

  handleOnClick = () => {
    this.props.onClick()
  }

  render () {
    const visibilityState = this.props.visible ? 'visible' : 'hidden';
    const modalClasses = ['modal', visibilityState]
    return (
      <div className={classNames(modalClasses)}>
        <div className="modalBody">
          {this.props.text}
          <div className="modalFooter">
            <Button
              label={this.props.buttonText}
              onClick={this.handleOnClick}
							primary
            />
          </div>
        </div>
      </div>
    )
  }
}
